export const SEE_INVENTORY_BY_PRICE = 'see_inventory_by_price';
